import { getCognitoAccessToken, getCognitoIdToken } from "@/lib/tokenStore";

/**
 * All /backend/api/* routes go through API Gateway with scope enforcement —
 * they require the access token (Cognito or Entra). The Cognito ID token has
 * no scopes and will be rejected with 401.
 */
export function bearerTokenForRequest(url) {
  return getCognitoAccessToken() || getCognitoIdToken();
}
